import PropTypes from 'prop-types';
import BPGrid from './BPTestTable';

const BPSection = ({
  sections,
  isEditing,
  localBPData,
  dropdownValues,
  errors,
  handleOnChange,
  handleBillableSettingsUnitChange,
  numberOfNotes,
  handleShowModal,
}) => {
  const renderData = (title) => {
    const data = localBPData[title]?.filter((row) => !row.hidden);
    if (!data) {
      return <BPGrid.Row title="Loading..." />;
    } else {
      return data.map((item, index) => {
        const hasError = errors?.[item?.subtitle] ? true : false;
        const isFeeWithUnit = item.Type === 'feeWithUnit';
        const unitOptions = isFeeWithUnit ? dropdownValues?.['Duty Admin Dropdown'] : undefined;
        const eoriTanOptions =
          item.subtitle === 'EORI TAN Usage - To be charged in'
            ? dropdownValues?.['EORI TAN Usage - To be charged in']
            : undefined;
        const dutyChargedToOptions =
          item.subtitle === 'Duty Charged to' ? dropdownValues?.['Duty Charged To'] : undefined;
        const effectiveDropdownValues = eoriTanOptions ?? dutyChargedToOptions ?? dropdownValues?.[item?.subtitle];

        const rowDependantField = item.requiresValueFromFieldId;
        const disableInput = rowDependantField && !data.find((s) => (s.id = rowDependantField))?.value;

        const traderEoriAndIsParent =
          item.subtitle === 'Trader EORI Number' && localBPData?.['Business Partner']?.[0]?.value === '20';
        const tooltip = traderEoriAndIsParent
          ? 'If this parent is also a trader, they must sign up as a trader via CABIE.'
          : '';
        const alternateSubtitle = traderEoriAndIsParent ? 'Unique Trader Reference' : '';

        return (
          <BPGrid.Row
            key={`${title}-${item?.subtitle}`}
            title={index === 0 ? title : ''}
            subTitle={item.subtitle}
            alternateSubtitle={alternateSubtitle}
            tooltip={tooltip}
            value={numberOfNotes || item.value}
            isEditingValue={isEditing}
            valueType={item.Type}
            dropdownValues={isFeeWithUnit ? undefined : effectiveDropdownValues}
            onUnitChange={title === 'Billable Settings' && isFeeWithUnit ? handleBillableSettingsUnitChange : undefined}
            onChange={handleOnChange}
            tableTitle={title}
            hasError={hasError}
            errorMessage={errors?.[item?.subtitle]}
            className={`bp-row-${index}`}
            hideDropDownDefaultSelectOption={title === 'Trader Settings'}
            setModalShow={handleShowModal}
            unit={item.unit}
            unitOptions={unitOptions}
            disabled={disableInput}
          />
        );
      });
    }
  };

  return (
    <>
      {sections.map(({ gridClassName, title }) => (
        <div key={title}>
          <div className="bp-section-heading">{title}</div>
          <BPGrid className={gridClassName} numCols={2} isEditing={isEditing}>
            {renderData(title)}
          </BPGrid>
        </div>
      ))}
    </>
  );
};

BPSection.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      gridClassName: PropTypes.string,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
  isEditing: PropTypes.bool.isRequired,
  localBPData: PropTypes.objectOf(PropTypes.array).isRequired,
  dropdownValues: PropTypes.objectOf(PropTypes.object).isRequired,
  errors: PropTypes.objectOf(PropTypes.string),
  handleOnChange: PropTypes.func.isRequired,
  handleBillableSettingsUnitChange: PropTypes.func.isRequired,
  numberOfNotes: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleShowModal: PropTypes.func.isRequired,
};

export default BPSection;
